import Vue from "vue";
import Vuex from "vuex";
import CookieHelper from "./helpers/CookieHelper";

Vue.use(Vuex);

//import productData from "@/assets/products.json";

export default new Vuex.Store({
  state: {
    userConsent: CookieHelper.getCookie("user-consent") || undefined,
    coldroom: sessionStorage? sessionStorage.getItem("coldroom") || undefined : undefined,
    coldroomSystem: sessionStorage? sessionStorage.getItem("coldroomSystem") || undefined : undefined,
    cutOutWidth: sessionStorage? sessionStorage.getItem("cutOutWidth") || undefined : undefined,
    cutOutHeight: sessionStorage? sessionStorage.getItem("cutOutHeight") || undefined : undefined,
    article: sessionStorage? sessionStorage.getItem("article") || undefined : undefined,
    kitFlanges: sessionStorage? sessionStorage.getItem("kitFlanges") || undefined : undefined,
    numberOfSystems: sessionStorage? sessionStorage.getItem("numberOfSystems") || undefined : undefined,
    totalSystem: sessionStorage? sessionStorage.getItem("totalSystem") || undefined : undefined,
    bestSystem: sessionStorage? sessionStorage.getItem("bestSystem") || undefined : undefined,
    suggestedHeight: sessionStorage? sessionStorage.getItem("suggestedHeight") || undefined : undefined,
    chosenItems: sessionStorage? sessionStorage.getItem("chosenItems") || undefined : undefined,
    computedAccessoires:
      sessionStorage? sessionStorage.getItem("computedAccessoires") || undefined : undefined,
    color: sessionStorage? sessionStorage.getItem("color") || undefined : undefined,
    shelvesPerDoor: sessionStorage? sessionStorage.getItem("shelvesPerDoor") || undefined : undefined,
    shelvingsSwitch: sessionStorage? sessionStorage.getItem("shelvingsSwitch") || undefined : undefined,
    shelvesWirePlate: sessionStorage? sessionStorage.getItem("shelvesWirePlate") || undefined : undefined,
    postsFrontBack: sessionStorage? sessionStorage.getItem("postsFrontBack") || undefined : undefined,
    gravitySheetSwitch:
      sessionStorage? sessionStorage.getItem("gravitySheetSwitch") || undefined : undefined,
    shelvesSingleDouble:
      sessionStorage? sessionStorage.getItem("shelvesSingleDouble") || undefined : undefined,
    containerStops: sessionStorage? sessionStorage.getItem("containerStops") || undefined : undefined,
    frontStopsPerShelf:
      sessionStorage? sessionStorage.getItem("frontStopsPerShelf") || undefined : undefined,
    dividersPerShelf: sessionStorage? sessionStorage.getItem("dividersPerShelf") || undefined : undefined,
    numberOfDoors: sessionStorage? sessionStorage.getItem("numberOfDoors") || undefined : undefined,
  },
  getters: {
    coldroom: (state) => {
      return state.coldroom;
    },
    coldroomSystem: (state) => {
      return state.coldroomSystem;
    },
    cutOutWidth: (state) => {
      return state.cutOutWidth;
    },
    cutOutHeight: (state) => {
      return state.cutOutHeight;
    },
    article: (state) => {
      return state.article;
    },
    kitFlanges: (state) => {
      return state.kitFlanges;
    },
    numberOfSystems: (state) => {
      return state.numberOfSystems;
    },
    totalSystem: (state) => {
      return state.totalSystem;
    },
    bestSystem: (state) => {
      return state.bestSystem;
    },
    suggestedHeight: (state) => {
      return state.suggestedHeight;
    },
    chosenItems: (state) => {
      return state.chosenItems;
    },
    computedAccessoires: (state) => {
      return state.computedAccessoires;
    },
    color: (state) => {
      return state.color;
    },
    shelvesPerDoor: (state) => {
      return state.shelvesPerDoor;
    },
    shelvingsSwitch: (state) => {
      return state.shelvingsSwitch;
    },
    shelvesWirePlate: (state) => {
      return state.shelvesWirePlate;
    },
    postsFrontBack: (state) => {
      return state.postsFrontBack;
    },
    gravitySheetSwitch: (state) => {
      return state.gravitySheetSwitch;
    },
    shelvesSingleDouble: (state) => {
      return state.shelvesSingleDouble;
    },
    containerStops: (state) => {
      return state.containerStops;
    },
    frontStopsPerShelf: (state) => {
      return state.frontStopsPerShelf;
    },
    dividersPerShelf: (state) => {
      return state.dividersPerShelf;
    },
    numberOfDoors: (state) => {
      return state.numberOfDoors;
    },

    userConsent: (state) => {
      //variable contains a cookie in the format necessary=true,analytics=true,marketing=true
      let returnValue = {
        necessary: undefined,
        analytics: undefined,
        marketing: undefined,
      };

      let cookieValues =
        state.userConsent != undefined ? state.userConsent.split(",") : [];

      for (let i = 0; i < cookieValues.length; i++) {
        let singleValue = cookieValues[i].split("=");
        returnValue[singleValue[0]] = "" + singleValue[1];
      }

      return returnValue;
    },
    onlineTrackingEnabled: (state, getters) => {
      let consent = getters.userConsent;

      let analytics =
        consent.analytics != undefined && consent.analytics == "true";

      return analytics;
    },
  },
  mutations: {
    setColdroom(state, coldroom) {
      state.coldroom = coldroom;
      if(sessionStorage)sessionStorage.setItem("coldroom", coldroom);
    },
    setColdroomSystem(state, coldroomSystem) {
      state.coldroomSystem = coldroomSystem;
      if(sessionStorage)sessionStorage.setItem("coldroomSystem", coldroomSystem);
    },
    setCutOutWidth(state, cutOutWidth) {
      state.cutOutWidth = cutOutWidth;
      if(sessionStorage)sessionStorage.setItem("cutOutWidth", cutOutWidth);
    },
    setCutOutHeight(state, cutOutHeight) {
      state.cutOutHeight = cutOutHeight;
      if(sessionStorage)sessionStorage.setItem("cutOutHeight", cutOutHeight);
    },
    setArticle(state, article) {
      state.article = article;
      if(sessionStorage)sessionStorage.setItem("article", article);
    },
    setKitFlanges(state, kitFlanges) {
      state.kitFlanges = kitFlanges;
      if(sessionStorage)sessionStorage.setItem("kitFlanges", kitFlanges);
    },
    setNumberOfSystems(state, numberOfSystems) {
      state.numberOfSystems = numberOfSystems;
      if(sessionStorage)sessionStorage.setItem("numberOfSystems", numberOfSystems);
    },
    setTotalSystem(state, totalSystem) {
      state.totalSystem = totalSystem;
      if(sessionStorage)sessionStorage.setItem("totalSystem", totalSystem);
    },
    setBestSystem(state, bestSystem) {
      state.bestSystem = bestSystem;
      if(sessionStorage)sessionStorage.setItem("bestSystem", bestSystem);
    },
    setSuggestedHeight(state, suggestedHeight) {
      state.suggestedHeight = suggestedHeight;
      if(sessionStorage)sessionStorage.setItem("suggestedHeight", suggestedHeight);
    },
    setChosenItems(state, chosenItems) {
      state.chosenItems = chosenItems;
      if(sessionStorage)sessionStorage.setItem("chosenItems", chosenItems);
    },
    setComputedAccessoires(state, computedAccessoires) {
      state.computedAccessoires = computedAccessoires;
      if(sessionStorage)sessionStorage.setItem("computedAccessoires", computedAccessoires);
    },
    setColor(state, color) {
      state.color = color;
      if(sessionStorage)sessionStorage.setItem("color", color);
    },
    setShelvesPerDoor(state, shelvesPerDoor) {
      state.shelvesPerDoor = shelvesPerDoor;
      if(sessionStorage)sessionStorage.setItem("shelvesPerDoor", shelvesPerDoor);
    },
    setShelvingsSwitch(state, shelvingsSwitch) {
      state.shelvingsSwitch = shelvingsSwitch;
      if(sessionStorage)sessionStorage.setItem("shelvingsSwitch", shelvingsSwitch);
    },
    setShelvesWirePlate(state, shelvesWirePlate) {
      state.shelvesWirePlate = shelvesWirePlate;
      if(sessionStorage)sessionStorage.setItem("shelvesWirePlate", shelvesWirePlate);
    },
    setPostsFrontBack(state, postsFrontBack) {
      state.postsFrontBack = postsFrontBack;
      if(sessionStorage)sessionStorage.setItem("postsFrontBack", postsFrontBack);
    },
    setGravitySheetSwitch(state, gravitySheetSwitch) {
      state.gravitySheetSwitch = gravitySheetSwitch;
      if(sessionStorage)sessionStorage.setItem("gravitySheetSwitch", gravitySheetSwitch);
    },
    setShelvesSingleDouble(state, shelvesSingleDouble) {
      state.shelvesSingleDouble = shelvesSingleDouble;
      if(sessionStorage)sessionStorage.setItem("shelvesSingleDouble", shelvesSingleDouble);
    },
    setContainerStops(state, containerStops) {
      state.containerStops = containerStops;
      if(sessionStorage)sessionStorage.setItem("containerStops", containerStops);
    },
    setFrontStopsPerShelf(state, frontStopsPerShelf) {
      state.frontStopsPerShelf = frontStopsPerShelf;
      if(sessionStorage)sessionStorage.setItem("frontStopsPerShelf", frontStopsPerShelf);
    },
    setDividersPerShelf(state, dividersPerShelf) {
      state.dividersPerShelf = dividersPerShelf;
      if(sessionStorage)sessionStorage.setItem("dividersPerShelf", dividersPerShelf);
    },
    setNumberOfDoors(state, numberOfDoors) {
      state.numberOfDoors = numberOfDoors;
      if(sessionStorage)sessionStorage.setItem("numberOfDoors", numberOfDoors);
    },

    setUserConsent(state, userConsent) {
      let strValue =
        "necessary=" +
        userConsent.necessary +
        ",analytics=" +
        userConsent.analytics +
        ",marketing=" +
        userConsent.marketing;

      state.userConsent = strValue;
      CookieHelper.createCookie("user-consent", strValue, 3650);
    },
    activateAllOnlineTracking() {
      this.commit("setUserConsent", {
        necessary: true,
        analytics: true,
        marketing: true,
      });
    },
  },
  actions: {
    async activateAllOnlineTracking({ commit }) {
      commit("activateAllOnlineTracking");
    },
    async changeCookiePreference({ commit }, userConsent) {
      commit("setUserConsent", userConsent);
    },
  },
});
